import { addTokensIfNeededDecorator } from './addTokensWhenNecessaryDecorator';

export const { withTokensIfNeeded, setRefreshTokenErrorHandler } = addTokensIfNeededDecorator();
